import { CouponDiscountType, Region } from "Infrastructure/Api/Api";
import { Resources, type TFunction } from "Translations/Resources";
import { z } from "zod";

const RESOURCES = Resources.Admin.Coupons.Validation;

const baseSchema = (t: TFunction) =>
  z.object({
    isAutoGenerate: z.boolean(),
    code: z.string().max(50).optional(),
    discount: z
      .number({ message: t(RESOURCES.DiscountRequired) })
      .positive(t(RESOURCES.DiscountPositive)),
    discountType: z.enum(CouponDiscountType),
    region: z.enum(Region),
    expirationDate: z.string().min(1, t(RESOURCES.ExpirationRequired)),
    initialStock: z
      .number({ message: t(RESOURCES.StockRequired) })
      .int()
      .min(1, t(RESOURCES.StockMin)),
  });

export type CreateCouponFormData = z.infer<ReturnType<typeof baseSchema>>;

export const getCreateCouponSchema = (t: TFunction) =>
  baseSchema(t)
    .refine(
      (data) => {
        if (data.discountType === CouponDiscountType.Percentage) {
          return data.discount <= 100;
        }
        return true;
      },
      {
        message: t(RESOURCES.DiscountMax100),
        path: ["discount"],
      },
    )
    .refine(
      (data) => {
        return (
          data.isAutoGenerate || (data.code && data.code.trim().length > 0)
        );
      },
      {
        message: t(RESOURCES.CodeRequired),
        path: ["code"],
      },
    );
